import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NewsManagerModalService {

  private selectedNewsManagerSubject = new BehaviorSubject<any>(null);
  public selectedNewsManager$ = this.selectedNewsManagerSubject.asObservable();

  constructor() { }

  setSelectedNewsManager(newsManager: any): void {
    this.selectedNewsManagerSubject.next(newsManager);
  }

  getSelectedNewsManager(): any | null {
    return this.selectedNewsManagerSubject.value;
  }

  clearSelectedNewsManager(): void {
    this.selectedNewsManagerSubject.next(null);
  }
}
